/* eslint-disable @next/next/no-img-element */
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react'
import { useShowThumbnailMap } from 'src/lib/optimizely/experiments/use-show-thumbnail-map'
import styled from 'styled-components'
import Image from 'next/image'
import { Container } from '@awaze/design-system.components.container'
import { Button } from '@awaze/design-system.components.button'
import { Link } from '@awaze/design-system.components.link'
import { trackOptimizelyClientsideEvent } from 'src/lib/optimizely/optimizely-for-client'
import { OPTIMIZELY_EVENT_AGE_ACQUISITION_CLICKED_ON_MAP } from 'src/constants'
import { useContext } from 'react'
import { GlobalProps } from 'src/utils/globalProps'
import { useIntl } from 'react-intl'
import { Headline } from '@awaze/design-system.components.text'
import { getAssetUrl } from 'src/utils/helpers/helpers'

const ThumbnailMapContainer = styled.div<{ center?: boolean }>`
  padding: ${pxToRems(40)} ${pxToRems(24)};

  @media (min-width: ${breakpoints[0]}px) {
    padding: ${pxToRems(64)} ${pxToRems(24)};
  }
  .map {
    margin-top: ${pxToRems(32)};
    position: relative;
    height: 416px;

    .link {
      position: relative;
      display: grid;
      place-items: center;
      height: 100%;
      width: 100%;

      > a {
        display: inline-grid;
        justify-items: center;
        text-decoration: none;
      }
    }
  }
`

const mapLinks = {
  novasol: '&range=3&nights=7&page=1&sort=priceasc&salesMarket=208',
  hoseasons: '&accommodationType=holiday-parks',
  fincallorca: '',
  jamesVillas: '',
  'cottages.com': '&accommodationType=cottages',
}

const mapRegionIfNovasol = {
  da: 5,
  hr: 3,
  'nl-NL': 13,
  fr: 6,
  de: 7,
  'de-AT': 1,
  'de-DE': 7,
  it: 10,
  nb: 14,
  pl: 15,
  es: 19,
  sv: 20,
}

export default function ThumbnailMap(): JSX.Element {
  const { formatMessage } = useIntl()

  const showMap = useShowThumbnailMap()
  const { brand, contentfulLocale, optimizelySdkKey, host, awazeClient } =
    useContext(GlobalProps)

  if (!showMap) {
    return
  }

  return (
    showMap && (
      <ThumbnailMapContainer>
        <Container>
          <Headline hasBorder as="h3" sizes={200}>
            {formatMessage({
              id: 'thumbnailMap.title',
              defaultMessage: 'All holiday houses in the area',
            })}
          </Headline>
          <div className="map">
            <img
              src={getAssetUrl('/images/map.jpg')}
              style={{
                objectFit: 'cover',
                position: 'absolute',
                height: '100%',
                width: '100%',
              }}
              alt="Map"
            />
            <div
              className="link"
              data-testid="map-link"
              onClick={() => {
                trackOptimizelyClientsideEvent(
                  optimizelySdkKey,
                  OPTIMIZELY_EVENT_AGE_ACQUISITION_CLICKED_ON_MAP,
                  brand,
                  contentfulLocale,
                  host,
                  awazeClient,
                )
              }}
            >
              <Link
                href={`/search?adult=2&child=0&infant=0&pets=0&displayMode=MAP&${
                  mapLinks[brand]
                }&placesId=${mapRegionIfNovasol[contentfulLocale] || ''}`}
              >
                <Image
                  height="60"
                  width="48"
                  src={getAssetUrl('/images/pin.svg')}
                  alt="Pin"
                />
                <Button
                  text={formatMessage({
                    id: 'thumbnailMap.showOnMap',
                    defaultMessage: 'Show on map',
                  })}
                  size="small"
                  colourScheme={'brand-primary'}
                />
              </Link>
            </div>
          </div>
        </Container>
      </ThumbnailMapContainer>
    )
  )
}
